import iconThemeColor from "../index";

const RemoveCircleOutlineIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 11.5C9.22386 11.5 9 11.7239 9 12C9 12.2761 9.22386 12.5 9.5 12.5H14.5C14.7761 12.5 15 12.2761 15 12C15 11.7239 14.7761 11.5 14.5 11.5H9.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

const AddCircleOutlineIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 9.5C12.5 9.22386 12.2761 9 12 9C11.7239 9 11.5 9.22386 11.5 9.5V11.5H9.5C9.22386 11.5 9 11.7239 9 12C9 12.2761 9.22386 12.5 9.5 12.5H11.5V14.5C11.5 14.7761 11.7239 15 12 15C12.2761 15 12.5 14.7761 12.5 14.5V12.5H14.5C14.7761 12.5 15 12.2761 15 12C15 11.7239 14.7761 11.5 14.5 11.5H12.5V9.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

const AddCircleOutlinedIconFilled = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM12.5 9.5C12.5 9.22386 12.2761 9 12 9C11.7239 9 11.5 9.22386 11.5 9.5V11.5H9.5C9.22386 11.5 9 11.7239 9 12C9 12.2761 9.22386 12.5 9.5 12.5H11.5V14.5C11.5 14.7761 11.7239 15 12 15C12.2761 15 12.5 14.7761 12.5 14.5V12.5H14.5C14.7761 12.5 15 12.2761 15 12C15 11.7239 14.7761 11.5 14.5 11.5H12.5V9.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const FilePen = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 6.5C6.5 5.67157 7.17157 5 8 5H11.5V7C11.5 8.38071 12.6193 9.5 14 9.5H17.5V14H18.5V9C18.5 8.84262 18.4259 8.69443 18.3 8.6L12.3 4.1C12.2135 4.03509 12.1082 4 12 4H8C6.61929 4 5.5 5.11929 5.5 6.5V17.5C5.5 18.8807 6.61929 20 8 20H13V19H8C7.17157 19 6.5 18.3284 6.5 17.5V6.5ZM16.5 8.5L12.5 5.5V7C12.5 7.82843 13.1716 8.5 14 8.5H16.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9053 13.6464C19.7124 13.4535 19.4004 13.4509 19.2042 13.6405L17.6524 15.1404L13.8854 18.9592C13.8103 19.0354 13.7615 19.1337 13.7464 19.2396L13.505 20.9293C13.4828 21.0851 13.5352 21.2423 13.6465 21.3536C13.7577 21.4648 13.9149 21.5172 14.0707 21.495L15.7604 21.2536C15.8663 21.2385 15.9646 21.1897 16.0408 21.1146L19.8512 17.3561L21.3595 15.7958C21.5491 15.5996 21.5465 15.2876 21.3536 15.0947L19.9053 13.6464ZM18.7905 16.9976L18.0024 16.2095L14.7131 19.5442L14.5893 20.4107L15.4558 20.2869L18.7905 16.9976ZM18.7132 15.506L19.494 16.2868L20.2988 15.4542L19.5458 14.7012L18.7132 15.506Z"
        fill={fillColor}
      />
    </svg>
  );
};

const MoreVertIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18C13.1046 18 14 18.8954 14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20C10 18.8954 10.8954 18 12 18Z"
        fill={fillColor}
      />
      <path
        d="M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
        fill={fillColor}
      />
      <path
        d="M14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4Z"
        fill={fillColor}
      />
    </svg>
  );
};

const MoreHorizIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10C5.10457 10 6 10.8954 6 12Z"
        fill={fillColor}
      />
      <path
        d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        fill={fillColor}
      />
      <path
        d="M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ThemedRemoveCircleOutlineIcon = iconThemeColor(RemoveCircleOutlineIcon);
export const ThemedAddCircleOutlineIcon = iconThemeColor(AddCircleOutlineIcon);
export const ThemedAddCircleOutlinedIconFilled = iconThemeColor(AddCircleOutlinedIconFilled);
export const ThemedFilePen = iconThemeColor(FilePen);
export const ThemedMoreVertIcon = iconThemeColor(MoreVertIcon);
export const ThemedMoreHorizIcon = iconThemeColor(MoreHorizIcon);
